import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Info } from "lucide-react";

import { useAuth } from "@/contexts/AuthContext";
import { getTenantCurrent } from "@/services/authService";
import { tenantKeys } from "@/lib/queryKeys";

/**
 * Shows a platform alert when the tenant is Literal E but the proof document
 * has not yet been verified. Renders nothing when fiscal benefits are disabled
 * (platform not proveedor habilitado) or when there is no active tenant.
 */
export function LiteralEPendingAlert(): JSX.Element | null {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data: tenant } = useQuery({
    queryKey: tenantKeys.current(user?.tenantId ?? undefined),
    queryFn: getTenantCurrent,
    enabled: Boolean(user?.tenantId),
  });

  const showAlert =
    Boolean(user?.tenantId) &&
    Boolean(tenant?.literalE) &&
    tenant?.literalEVerified !== true;

  if (!showAlert) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200"
    >
      <Info className="h-4 w-4 shrink-0" aria-hidden />
      <p className="font-medium">
        {t("header.literalEPendingVerification")}
      </p>
    </div>
  );
}
